const dateFormatter = new Intl.DateTimeFormat('zh-CN', {
  timeZone: 'Asia/Shanghai',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

function shanghaiDateOf(d: Date): string {
  const parts = dateFormatter.formatToParts(d);
  const lookup = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return `${lookup.year}-${lookup.month}-${lookup.day}`;
}

export function todayIsoDate(): string {
  return shanghaiDateOf(new Date());
}

export function tomorrowIsoDate(): string {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return shanghaiDateOf(d);
}

export function nDaysAgoIsoDate(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return shanghaiDateOf(d);
}

export function yesterdayIsoDate(): string {
  return nDaysAgoIsoDate(1);
}

export function formatDate(
  value: string | number | Date | null | undefined,
  fallback = '-',
): string {
  if (value === null || value === undefined || value === '') return fallback;
  // YYYY-MM-DD strings must be treated as local date, not UTC midnight
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    const [y, m, d] = value.split('-');
    return `${y}-${m}-${d}`;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return shanghaiDateOf(date);
}

const dateTimeFormatter = new Intl.DateTimeFormat('zh-CN', {
  timeZone: 'Asia/Shanghai',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export function formatDateTime(
  value: string | number | Date | null | undefined,
  fallback = '-',
): string {
  if (value === null || value === undefined || value === '') return fallback;

  const normalizedValue =
    typeof value === 'string' && /^\d+$/.test(value.trim()) ? Number(value) : value;

  const date = normalizedValue instanceof Date ? normalizedValue : new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) return fallback;

  const parts = dateTimeFormatter.formatToParts(date);
  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]));

  return `${lookup.year}-${lookup.month}-${lookup.day} ${lookup.hour}:${lookup.minute}:${lookup.second}`;
}
